@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(1_946_883_011)
internal val Res.string.ui_app_instance_edit_wheel_game_editor: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_game_editor", "ui_app_instance_edit_wheel_game_editor", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4914, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4714, 70),
      ))
    }

@delegate:ResourceContentHash(164_416_545)
internal val Res.string.ui_app_instance_edit_wheel_items: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_items", "ui_app_instance_edit_wheel_items", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4989, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4785, 56),
      ))
    }

@delegate:ResourceContentHash(277_234_640)
internal val Res.string.ui_app_instance_edit_wheel_position_x: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_position_x", "ui_app_instance_edit_wheel_position_x", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5054, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4842, 69),
      ))
    }

@delegate:ResourceContentHash(277_250_047)
internal val Res.string.ui_app_instance_edit_wheel_position_y: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_position_y", "ui_app_instance_edit_wheel_position_y", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5120, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4912, 69),
      ))
    }

@delegate:ResourceContentHash(-580_162_867)
internal val Res.string.ui_app_instance_edit_wheel_scale: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_scale", "ui_app_instance_edit_wheel_scale", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5186, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4982, 56),
      ))
    }

@delegate:ResourceContentHash(-1_905_461_390)
internal val Res.string.ui_apps_listing_header_instance: StringResource by lazy {
      StringResource("string:ui_apps_listing_header_instance", "ui_apps_listing_header_instance", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5247, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5039, 67),
      ))
    }

@delegate:ResourceContentHash(-343_871_506)
internal val Res.string.ui_apps_listing_header_type_company: StringResource by lazy {
      StringResource("string:ui_apps_listing_header_type_company", "ui_apps_listing_header_type_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5315, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5107, 63),
      ))
    }

@delegate:ResourceContentHash(-1_739_759_720)
internal val Res.string.ui_apps_listing_no_apps_found: StringResource by lazy {
      StringResource("string:ui_apps_listing_no_apps_found", "ui_apps_listing_no_apps_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5379, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5171, 65),
      ))
    }

@delegate:ResourceContentHash(1_000_806_598)
internal val Res.string.ui_apps_listing_showing: StringResource by lazy {
      StringResource("string:ui_apps_listing_showing", "ui_apps_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5453, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5237, 87),
      ))
    }

@delegate:ResourceContentHash(948_401_326)
internal val Res.string.ui_apps_listing_unknown: StringResource by lazy {
      StringResource("string:ui_apps_listing_unknown", "ui_apps_listing_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5541, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5325, 43),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_campaigns_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_delete", "ui_campaigns_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5585, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5369, 46),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_campaigns_detail_btn_edit: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_edit", "ui_campaigns_detail_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5636, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5416, 44),
      ))
    }

@delegate:ResourceContentHash(-109_023_434)
internal val Res.string.ui_campaigns_detail_btn_pause: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_pause", "ui_campaigns_detail_btn_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5681, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5461, 45),
      ))
    }

@delegate:ResourceContentHash(1_765_233_829)
internal val Res.string.ui_campaigns_detail_btn_resume: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_resume", "ui_campaigns_detail_btn_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5731, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5507, 46),
      ))
    }

@delegate:ResourceContentHash(376_450_631)
internal val Res.string.ui_campaigns_detail_device_cluster: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_device_cluster", "ui_campaigns_detail_device_cluster", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5782, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5554, 62),
      ))
    }

@delegate:ResourceContentHash(-1_767_816_274)
internal val Res.string.ui_campaigns_detail_geo_nodes: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_geo_nodes", "ui_campaigns_detail_geo_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5849, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5617, 49),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_campaigns_detail_locations: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_locations", "ui_campaigns_detail_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5903, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5667, 49),
      ))
    }

@delegate:ResourceContentHash(1_559_678_106)
internal val Res.string.ui_campaigns_detail_media_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_media_assets", "ui_campaigns_detail_media_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5953, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5717, 56),
      ))
    }

@delegate:ResourceContentHash(1_102_380_134)
internal val Res.string.ui_campaigns_detail_overview: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_overview", "ui_campaigns_detail_overview", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6018, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5774, 48),
      ))
    }

@delegate:ResourceContentHash(-2_053_283_646)
internal val Res.string.ui_campaigns_detail_reach_estimate: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_reach_estimate", "ui_campaigns_detail_reach_estimate", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6067, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5823, 62),
      ))
    }

@delegate:ResourceContentHash(-1_315_232_960)
internal val Res.string.ui_campaigns_detail_status: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_status", "ui_campaigns_detail_status", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6130, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5886, 42),
      ))
    }

@delegate:ResourceContentHash(1_221_190_687)
internal val Res.string.ui_campaigns_detail_total_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_total_assets", "ui_campaigns_detail_total_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6173, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5929, 56),
      ))
    }

@delegate:ResourceContentHash(1_811_251_413)
internal val Res.string.ui_campaigns_edit_activation_date: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_activation_date", "ui_campaigns_edit_activation_date", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6234, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5986, 61),
      ))
    }

@delegate:ResourceContentHash(1_449_379_509)
internal val Res.string.ui_campaigns_edit_assets_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_assets_title", "ui_campaigns_edit_assets_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6300, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6048, 46),
      ))
    }

@delegate:ResourceContentHash(-267_574_627)
internal val Res.string.ui_campaigns_edit_btn_activate: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_activate", "ui_campaigns_edit_btn_activate", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6351, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6095, 62),
      ))
    }

@delegate:ResourceContentHash(-1_807_433_538)
internal val Res.string.ui_campaigns_edit_btn_back: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_back", "ui_campaigns_edit_btn_back", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6414, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6158, 42),
      ))
    }

@delegate:ResourceContentHash(-133_818_720)
internal val Res.string.ui_campaigns_edit_btn_clear: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_clear", "ui_campaigns_edit_btn_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6457, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6201, 43),
      ))
    }

@delegate:ResourceContentHash(-1_594_403_747)
internal val Res.string.ui_campaigns_edit_btn_close: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_close", "ui_campaigns_edit_btn_close", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6505, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6245, 43),
      ))
    }

@delegate:ResourceContentHash(-697_943_661)
internal val Res.string.ui_campaigns_edit_btn_pick_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_pick_assets", "ui_campaigns_edit_btn_pick_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6553, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6289, 57),
      ))
    }

@delegate:ResourceContentHash(-1_176_198_193)
internal val Res.string.ui_campaigns_edit_btn_pick_locations: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_pick_locations", "ui_campaigns_edit_btn_pick_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6615, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6347, 64),
      ))
    }

@delegate:ResourceContentHash(907_211_613)
internal val Res.string.ui_campaigns_edit_btn_save_draft: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_save_draft", "ui_campaigns_edit_btn_save_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6684, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6412, 60),
      ))
    }

@delegate:ResourceContentHash(-281_068_966)
internal val Res.string.ui_campaigns_edit_btn_select_all: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_select_all", "ui_campaigns_edit_btn_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6749, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6473, 56),
      ))
    }

@delegate:ResourceContentHash(1_474_369_607)
internal val Res.string.ui_campaigns_edit_btn_unselect_all: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_unselect_all", "ui_campaigns_edit_btn_unselect_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6806, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6530, 58),
      ))
    }

@delegate:ResourceContentHash(873_502_057)
internal val Res.string.ui_campaigns_edit_campaign_name: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_campaign_name", "ui_campaigns_edit_campaign_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6961, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6669, 59),
      ))
    }

@delegate:ResourceContentHash(1_440_206_068)
internal val Res.string.ui_campaigns_edit_campaign_name_placeholder: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_campaign_name_placeholder", "ui_campaigns_edit_campaign_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6877, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6589, 79),
      ))
    }

@delegate:ResourceContentHash(-2_006_097_926)
internal val Res.string.ui_campaigns_edit_commencement: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_commencement", "ui_campaigns_edit_commencement", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7021, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6729, 54),
      ))
    }

@delegate:ResourceContentHash(-1_181_280_874)
internal val Res.string.ui_campaigns_edit_deployment_zone: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_deployment_zone", "ui_campaigns_edit_deployment_zone", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7072, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6784, 61),
      ))
    }

@delegate:ResourceContentHash(1_032_257_010)
internal val Res.string.ui_campaigns_edit_duration_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_desc", "ui_campaigns_edit_duration_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7138, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6846, 159),
      ))
    }

@delegate:ResourceContentHash(701_721_428)
internal val Res.string.ui_campaigns_edit_duration_field_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_field_desc", "ui_campaigns_edit_duration_field_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7306, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7006, 269),
      ))
    }

@delegate:ResourceContentHash(396_888_822)
internal val Res.string.ui_campaigns_edit_duration_field_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_field_title", "ui_campaigns_edit_duration_field_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7568, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7276, 82),
      ))
    }

@delegate:ResourceContentHash(96_004_440)
internal val Res.string.ui_campaigns_edit_duration_seconds_suffix: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_seconds_suffix", "ui_campaigns_edit_duration_seconds_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7655, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7359, 53),
      ))
    }

@delegate:ResourceContentHash(1_132_501_738)
internal val Res.string.ui_campaigns_edit_duration_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_title", "ui_campaigns_edit_duration_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7709, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7413, 52),
      ))
    }

@delegate:ResourceContentHash(-569_596_359)
internal val Res.string.ui_campaigns_edit_expiration_date: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_expiration_date", "ui_campaigns_edit_expiration_date", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7762, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7466, 61),
      ))
    }

@delegate:ResourceContentHash(-353_145_663)
internal val Res.string.ui_campaigns_edit_identity_schedule: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_identity_schedule", "ui_campaigns_edit_identity_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7820, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7528, 71),
      ))
    }

@delegate:ResourceContentHash(-531_875_519)
internal val Res.string.ui_campaigns_edit_immediate: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_immediate", "ui_campaigns_edit_immediate", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7892, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7600, 47),
      ))
    }

@delegate:ResourceContentHash(-1_050_558_054)
internal val Res.string.ui_campaigns_edit_locations_selected: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_locations_selected", "ui_campaigns_edit_locations_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 7936, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7648, 68),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_campaigns_edit_locations_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_locations_title", "ui_campaigns_edit_locations_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8005, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7717, 53),
      ))
    }

@delegate:ResourceContentHash(421_593_902)
internal val Res.string.ui_campaigns_edit_no_locations_found: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_no_locations_found", "ui_campaigns_edit_no_locations_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8059, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7771, 100),
      ))
    }

@delegate:ResourceContentHash(-954_332_803)
internal val Res.string.ui_campaigns_edit_nodes: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nodes", "ui_campaigns_edit_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8239, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7927, 39),
      ))
    }

@delegate:ResourceContentHash(-55_599_751)
internal val Res.string.ui_campaigns_edit_nodes_active: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nodes_active", "ui_campaigns_edit_nodes_active", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8176, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7872, 54),
      ))
    }

@delegate:ResourceContentHash(-220_012_296)
internal val Res.string.ui_campaigns_edit_nomenclature_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nomenclature_desc", "ui_campaigns_edit_nomenclature_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8283, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7967, 219),
      ))
    }

@delegate:ResourceContentHash(-862_359_620)
internal val Res.string.ui_campaigns_edit_nomenclature_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nomenclature_title", "ui_campaigns_edit_nomenclature_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8503, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8187, 60),
      ))
    }

@delegate:ResourceContentHash(543_457_831)
internal val Res.string.ui_campaigns_edit_perpetual: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_perpetual", "ui_campaigns_edit_perpetual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8564, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8248, 47),
      ))
    }

@delegate:ResourceContentHash(-1_126_320_535)
internal val Res.string.ui_campaigns_edit_primary_designation: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_primary_designation", "ui_campaigns_edit_primary_designation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8608, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8296, 73),
      ))
    }

@delegate:ResourceContentHash(-403_237_092)
internal val Res.string.ui_campaigns_edit_scheduling_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_scheduling_desc", "ui_campaigns_edit_scheduling_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8674, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8370, 157),
      ))
    }

@delegate:ResourceContentHash(2_029_462_745)
internal val Res.string.ui_campaigns_edit_scheduling_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_scheduling_title", "ui_campaigns_edit_scheduling_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8828, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8528, 58),
      ))
    }

@delegate:ResourceContentHash(165_300_970)
internal val Res.string.ui_campaigns_edit_search_placeholder: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_search_placeholder", "ui_campaigns_edit_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8883, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8587, 88),
      ))
    }

@delegate:ResourceContentHash(-1_169_956_721)
internal val Res.string.ui_campaigns_edit_select_from_library: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_select_from_library", "ui_campaigns_edit_select_from_library", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9103, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8779, 73),
      ))
    }

@delegate:ResourceContentHash(952_150_861)
internal val Res.string.ui_campaigns_edit_select_from_library_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_select_from_library_desc", "ui_campaigns_edit_select_from_library_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 8988, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8676, 102),
      ))
    }

@delegate:ResourceContentHash(-841_910_432)
internal val Res.string.ui_campaigns_edit_step_format: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_step_format", "ui_campaigns_edit_step_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9177, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8853, 45),
      ))
    }

@delegate:ResourceContentHash(2_082_368_184)
internal val Res.string.ui_campaigns_edit_targeting_requirements_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_targeting_requirements_desc", "ui_campaigns_edit_targeting_requirements_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9223, 501),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8899, 453),
      ))
    }

@delegate:ResourceContentHash(1_133_861)
internal val Res.string.ui_campaigns_edit_targeting_requirements_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_targeting_requirements_title", "ui_campaigns_edit_targeting_requirements_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9725, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9353, 86),
      ))
    }

@delegate:ResourceContentHash(1_180_400_046)
internal val Res.string.ui_campaigns_edit_targeting_summary: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_targeting_summary", "ui_campaigns_edit_targeting_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9804, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9440, 67),
      ))
    }

@delegate:ResourceContentHash(-1_378_167_346)
internal val Res.string.ui_campaigns_edit_temporal_parameters: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_temporal_parameters", "ui_campaigns_edit_temporal_parameters", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9872, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9508, 73),
      ))
    }

@delegate:ResourceContentHash(-2_003_870_425)
internal val Res.string.ui_campaigns_edit_termination: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_termination", "ui_campaigns_edit_termination", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 9946, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9582, 53),
      ))
    }

@delegate:ResourceContentHash(-433_275_553)
internal val Res.string.ui_campaigns_edit_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_title", "ui_campaigns_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10000, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9636, 51),
      ))
    }

@delegate:ResourceContentHash(1_187_313_072)
internal val Res.string.ui_campaigns_edit_visual_guidelines_multiple: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_visual_guidelines_multiple", "ui_campaigns_edit_visual_guidelines_multiple", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10056, 776),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9688, 704),
      ))
    }

@delegate:ResourceContentHash(1_859_646_285)
internal val Res.string.ui_campaigns_edit_visual_guidelines_single: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_visual_guidelines_single", "ui_campaigns_edit_visual_guidelines_single", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10833, 546),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10393, 518),
      ))
    }

@delegate:ResourceContentHash(1_993_030_060)
internal val Res.string.ui_campaigns_edit_visual_guidelines_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_visual_guidelines_title", "ui_campaigns_edit_visual_guidelines_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11380, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10912, 73),
      ))
    }

@delegate:ResourceContentHash(-1_578_765_116)
internal val Res.string.ui_campaigns_edit_warn_name_required: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_name_required", "ui_campaigns_edit_warn_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11458, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10986, 80),
      ))
    }

@delegate:ResourceContentHash(-103_907_719)
internal val Res.string.ui_campaigns_edit_warn_save_failed: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_save_failed", "ui_campaigns_edit_warn_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11539, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11067, 58),
      ))
    }

@delegate:ResourceContentHash(196_120_729)
internal val Res.string.ui_campaigns_edit_warn_select_device: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_select_device", "ui_campaigns_edit_warn_select_device", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11614, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11126, 80),
      ))
    }

@delegate:ResourceContentHash(-2_134_920_235)
internal val Res.string.ui_campaigns_edit_warn_set_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_warn_set_assets", "ui_campaigns_edit_warn_set_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11699, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11207, 85),
      ))
    }

@delegate:ResourceContentHash(-1_238_941_292)
internal val Res.string.ui_campaigns_listing_btn_new: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_btn_new", "ui_campaigns_listing_btn_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11793, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11293, 48),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.ui_campaigns_listing_btn_ok: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_btn_ok", "ui_campaigns_listing_btn_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11842, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11342, 39),
      ))
    }

@delegate:ResourceContentHash(44_400_671)
internal val Res.string.ui_campaigns_listing_btn_reset: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_btn_reset", "ui_campaigns_listing_btn_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11886, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11382, 46),
      ))
    }

@delegate:ResourceContentHash(-2_129_802_091)
internal val Res.string.ui_campaigns_listing_filter_date_any: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_filter_date_any", "ui_campaigns_listing_filter_date_any", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 11945, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11429, 56),
      ))
    }

@delegate:ResourceContentHash(1_566_795_854)
internal val Res.string.ui_campaigns_listing_filter_date_format: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_filter_date_format", "ui_campaigns_listing_filter_date_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12014, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11486, 63),
      ))
    }

@delegate:ResourceContentHash(914_843_083)
internal val Res.string.ui_campaigns_listing_filter_state_prefix: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_filter_state_prefix", "ui_campaigns_listing_filter_state_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12078, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11550, 56),
      ))
    }

@delegate:ResourceContentHash(752_949_821)
internal val Res.string.ui_campaigns_listing_header_asset: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_asset", "ui_campaigns_listing_header_asset", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12139, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11607, 49),
      ))
    }

@delegate:ResourceContentHash(79_735_552)
internal val Res.string.ui_campaigns_listing_header_geo: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_geo", "ui_campaigns_listing_header_geo", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12189, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11657, 43),
      ))
    }

@delegate:ResourceContentHash(-32_286_540)
internal val Res.string.ui_campaigns_listing_header_identity: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_identity", "ui_campaigns_listing_header_identity", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12233, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11701, 56),
      ))
    }

@delegate:ResourceContentHash(1_686_638_496)
internal val Res.string.ui_campaigns_listing_header_interval: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_interval", "ui_campaigns_listing_header_interval", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12290, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11758, 56),
      ))
    }

@delegate:ResourceContentHash(464_968_481)
internal val Res.string.ui_campaigns_listing_header_node: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_node", "ui_campaigns_listing_header_node", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12347, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11815, 48),
      ))
    }

@delegate:ResourceContentHash(157_918_156)
internal val Res.string.ui_campaigns_listing_header_reach: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_reach", "ui_campaigns_listing_header_reach", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12396, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11864, 49),
      ))
    }

@delegate:ResourceContentHash(-1_315_954_198)
internal val Res.string.ui_campaigns_listing_header_state: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_state", "ui_campaigns_listing_header_state", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12446, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11914, 49),
      ))
    }

@delegate:ResourceContentHash(-191_297_421)
internal val Res.string.ui_campaigns_listing_header_visual: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_header_visual", "ui_campaigns_listing_header_visual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12496, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11964, 50),
      ))
    }

@delegate:ResourceContentHash(-509_402_608)
internal val Res.string.ui_campaigns_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_search_placeholder", "ui_campaigns_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12547, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12015, 63),
      ))
    }

@delegate:ResourceContentHash(-1_669_178_289)
internal val Res.string.ui_campaigns_listing_showing: StringResource by lazy {
      StringResource("string:ui_campaigns_listing_showing", "ui_campaigns_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12627, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12079, 84),
      ))
    }

@delegate:ResourceContentHash(255_620_874)
internal val Res.string.ui_campaigns_splash_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_splash_desc", "ui_campaigns_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12716, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12164, 196),
      ))
    }

@delegate:ResourceContentHash(2_075_806_342)
internal val Res.string.ui_campaigns_splash_title: StringResource by lazy {
      StringResource("string:ui_campaigns_splash_title", "ui_campaigns_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12929, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12361, 45),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_company_dialog_btn_cancel: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_cancel", "ui_company_dialog_btn_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 12975, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12407, 44),
      ))
    }

@delegate:ResourceContentHash(-1_918_958_121)
internal val Res.string.ui_company_dialog_btn_confirm: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_confirm", "ui_company_dialog_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13024, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12452, 49),
      ))
    }

@delegate:ResourceContentHash(-1_259_938_483)
internal val Res.string.ui_company_dialog_btn_delete: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_delete", "ui_company_dialog_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13074, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12502, 56),
      ))
    }

@delegate:ResourceContentHash(1_437_937_459)
internal val Res.string.ui_company_dialog_btn_rename: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_rename", "ui_company_dialog_btn_rename", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13131, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12559, 56),
      ))
    }

@delegate:ResourceContentHash(-1_246_631_216)
internal val Res.string.ui_company_dialog_btn_switch: StringResource by lazy {
      StringResource("string:ui_company_dialog_btn_switch", "ui_company_dialog_btn_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13192, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12616, 60),
      ))
    }

@delegate:ResourceContentHash(1_062_343_038)
internal val Res.string.ui_company_dialog_delete_title: StringResource by lazy {
      StringResource("string:ui_company_dialog_delete_title", "ui_company_dialog_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13257, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12677, 58),
      ))
    }

@delegate:ResourceContentHash(-534_585_888)
internal val Res.string.ui_company_dialog_delete_warning: StringResource by lazy {
      StringResource("string:ui_company_dialog_delete_warning", "ui_company_dialog_delete_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13316, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12736, 240),
      ))
    }

@delegate:ResourceContentHash(-69_592_949)
internal val Res.string.ui_company_dialog_rename_placeholder: StringResource by lazy {
      StringResource("string:ui_company_dialog_rename_placeholder", "ui_company_dialog_rename_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13585, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12977, 60),
      ))
    }

@delegate:ResourceContentHash(1_824_521_994)
internal val Res.string.ui_company_dialog_rename_title: StringResource by lazy {
      StringResource("string:ui_company_dialog_rename_title", "ui_company_dialog_rename_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 13650, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13038, 58),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_app_instance_edit_wheel_game_editor", Res.string.ui_app_instance_edit_wheel_game_editor)
  map.put("ui_app_instance_edit_wheel_items", Res.string.ui_app_instance_edit_wheel_items)
  map.put("ui_app_instance_edit_wheel_position_x", Res.string.ui_app_instance_edit_wheel_position_x)
  map.put("ui_app_instance_edit_wheel_position_y", Res.string.ui_app_instance_edit_wheel_position_y)
  map.put("ui_app_instance_edit_wheel_scale", Res.string.ui_app_instance_edit_wheel_scale)
  map.put("ui_apps_listing_header_instance", Res.string.ui_apps_listing_header_instance)
  map.put("ui_apps_listing_header_type_company", Res.string.ui_apps_listing_header_type_company)
  map.put("ui_apps_listing_no_apps_found", Res.string.ui_apps_listing_no_apps_found)
  map.put("ui_apps_listing_showing", Res.string.ui_apps_listing_showing)
  map.put("ui_apps_listing_unknown", Res.string.ui_apps_listing_unknown)
  map.put("ui_campaigns_detail_btn_delete", Res.string.ui_campaigns_detail_btn_delete)
  map.put("ui_campaigns_detail_btn_edit", Res.string.ui_campaigns_detail_btn_edit)
  map.put("ui_campaigns_detail_btn_pause", Res.string.ui_campaigns_detail_btn_pause)
  map.put("ui_campaigns_detail_btn_resume", Res.string.ui_campaigns_detail_btn_resume)
  map.put("ui_campaigns_detail_device_cluster", Res.string.ui_campaigns_detail_device_cluster)
  map.put("ui_campaigns_detail_geo_nodes", Res.string.ui_campaigns_detail_geo_nodes)
  map.put("ui_campaigns_detail_locations", Res.string.ui_campaigns_detail_locations)
  map.put("ui_campaigns_detail_media_assets", Res.string.ui_campaigns_detail_media_assets)
  map.put("ui_campaigns_detail_overview", Res.string.ui_campaigns_detail_overview)
  map.put("ui_campaigns_detail_reach_estimate", Res.string.ui_campaigns_detail_reach_estimate)
  map.put("ui_campaigns_detail_status", Res.string.ui_campaigns_detail_status)
  map.put("ui_campaigns_detail_total_assets", Res.string.ui_campaigns_detail_total_assets)
  map.put("ui_campaigns_edit_activation_date", Res.string.ui_campaigns_edit_activation_date)
  map.put("ui_campaigns_edit_assets_title", Res.string.ui_campaigns_edit_assets_title)
  map.put("ui_campaigns_edit_btn_activate", Res.string.ui_campaigns_edit_btn_activate)
  map.put("ui_campaigns_edit_btn_back", Res.string.ui_campaigns_edit_btn_back)
  map.put("ui_campaigns_edit_btn_clear", Res.string.ui_campaigns_edit_btn_clear)
  map.put("ui_campaigns_edit_btn_close", Res.string.ui_campaigns_edit_btn_close)
  map.put("ui_campaigns_edit_btn_pick_assets", Res.string.ui_campaigns_edit_btn_pick_assets)
  map.put("ui_campaigns_edit_btn_pick_locations", Res.string.ui_campaigns_edit_btn_pick_locations)
  map.put("ui_campaigns_edit_btn_save_draft", Res.string.ui_campaigns_edit_btn_save_draft)
  map.put("ui_campaigns_edit_btn_select_all", Res.string.ui_campaigns_edit_btn_select_all)
  map.put("ui_campaigns_edit_btn_unselect_all", Res.string.ui_campaigns_edit_btn_unselect_all)
  map.put("ui_campaigns_edit_campaign_name", Res.string.ui_campaigns_edit_campaign_name)
  map.put("ui_campaigns_edit_campaign_name_placeholder", Res.string.ui_campaigns_edit_campaign_name_placeholder)
  map.put("ui_campaigns_edit_commencement", Res.string.ui_campaigns_edit_commencement)
  map.put("ui_campaigns_edit_deployment_zone", Res.string.ui_campaigns_edit_deployment_zone)
  map.put("ui_campaigns_edit_duration_desc", Res.string.ui_campaigns_edit_duration_desc)
  map.put("ui_campaigns_edit_duration_field_desc", Res.string.ui_campaigns_edit_duration_field_desc)
  map.put("ui_campaigns_edit_duration_field_title", Res.string.ui_campaigns_edit_duration_field_title)
  map.put("ui_campaigns_edit_duration_seconds_suffix", Res.string.ui_campaigns_edit_duration_seconds_suffix)
  map.put("ui_campaigns_edit_duration_title", Res.string.ui_campaigns_edit_duration_title)
  map.put("ui_campaigns_edit_expiration_date", Res.string.ui_campaigns_edit_expiration_date)
  map.put("ui_campaigns_edit_identity_schedule", Res.string.ui_campaigns_edit_identity_schedule)
  map.put("ui_campaigns_edit_immediate", Res.string.ui_campaigns_edit_immediate)
  map.put("ui_campaigns_edit_locations_selected", Res.string.ui_campaigns_edit_locations_selected)
  map.put("ui_campaigns_edit_locations_title", Res.string.ui_campaigns_edit_locations_title)
  map.put("ui_campaigns_edit_no_locations_found", Res.string.ui_campaigns_edit_no_locations_found)
  map.put("ui_campaigns_edit_nodes", Res.string.ui_campaigns_edit_nodes)
  map.put("ui_campaigns_edit_nodes_active", Res.string.ui_campaigns_edit_nodes_active)
  map.put("ui_campaigns_edit_nomenclature_desc", Res.string.ui_campaigns_edit_nomenclature_desc)
  map.put("ui_campaigns_edit_nomenclature_title", Res.string.ui_campaigns_edit_nomenclature_title)
  map.put("ui_campaigns_edit_perpetual", Res.string.ui_campaigns_edit_perpetual)
  map.put("ui_campaigns_edit_primary_designation", Res.string.ui_campaigns_edit_primary_designation)
  map.put("ui_campaigns_edit_scheduling_desc", Res.string.ui_campaigns_edit_scheduling_desc)
  map.put("ui_campaigns_edit_scheduling_title", Res.string.ui_campaigns_edit_scheduling_title)
  map.put("ui_campaigns_edit_search_placeholder", Res.string.ui_campaigns_edit_search_placeholder)
  map.put("ui_campaigns_edit_select_from_library", Res.string.ui_campaigns_edit_select_from_library)
  map.put("ui_campaigns_edit_select_from_library_desc", Res.string.ui_campaigns_edit_select_from_library_desc)
  map.put("ui_campaigns_edit_step_format", Res.string.ui_campaigns_edit_step_format)
  map.put("ui_campaigns_edit_targeting_requirements_desc", Res.string.ui_campaigns_edit_targeting_requirements_desc)
  map.put("ui_campaigns_edit_targeting_requirements_title", Res.string.ui_campaigns_edit_targeting_requirements_title)
  map.put("ui_campaigns_edit_targeting_summary", Res.string.ui_campaigns_edit_targeting_summary)
  map.put("ui_campaigns_edit_temporal_parameters", Res.string.ui_campaigns_edit_temporal_parameters)
  map.put("ui_campaigns_edit_termination", Res.string.ui_campaigns_edit_termination)
  map.put("ui_campaigns_edit_title", Res.string.ui_campaigns_edit_title)
  map.put("ui_campaigns_edit_visual_guidelines_multiple", Res.string.ui_campaigns_edit_visual_guidelines_multiple)
  map.put("ui_campaigns_edit_visual_guidelines_single", Res.string.ui_campaigns_edit_visual_guidelines_single)
  map.put("ui_campaigns_edit_visual_guidelines_title", Res.string.ui_campaigns_edit_visual_guidelines_title)
  map.put("ui_campaigns_edit_warn_name_required", Res.string.ui_campaigns_edit_warn_name_required)
  map.put("ui_campaigns_edit_warn_save_failed", Res.string.ui_campaigns_edit_warn_save_failed)
  map.put("ui_campaigns_edit_warn_select_device", Res.string.ui_campaigns_edit_warn_select_device)
  map.put("ui_campaigns_edit_warn_set_assets", Res.string.ui_campaigns_edit_warn_set_assets)
  map.put("ui_campaigns_listing_btn_new", Res.string.ui_campaigns_listing_btn_new)
  map.put("ui_campaigns_listing_btn_ok", Res.string.ui_campaigns_listing_btn_ok)
  map.put("ui_campaigns_listing_btn_reset", Res.string.ui_campaigns_listing_btn_reset)
  map.put("ui_campaigns_listing_filter_date_any", Res.string.ui_campaigns_listing_filter_date_any)
  map.put("ui_campaigns_listing_filter_date_format", Res.string.ui_campaigns_listing_filter_date_format)
  map.put("ui_campaigns_listing_filter_state_prefix", Res.string.ui_campaigns_listing_filter_state_prefix)
  map.put("ui_campaigns_listing_header_asset", Res.string.ui_campaigns_listing_header_asset)
  map.put("ui_campaigns_listing_header_geo", Res.string.ui_campaigns_listing_header_geo)
  map.put("ui_campaigns_listing_header_identity", Res.string.ui_campaigns_listing_header_identity)
  map.put("ui_campaigns_listing_header_interval", Res.string.ui_campaigns_listing_header_interval)
  map.put("ui_campaigns_listing_header_node", Res.string.ui_campaigns_listing_header_node)
  map.put("ui_campaigns_listing_header_reach", Res.string.ui_campaigns_listing_header_reach)
  map.put("ui_campaigns_listing_header_state", Res.string.ui_campaigns_listing_header_state)
  map.put("ui_campaigns_listing_header_visual", Res.string.ui_campaigns_listing_header_visual)
  map.put("ui_campaigns_listing_search_placeholder", Res.string.ui_campaigns_listing_search_placeholder)
  map.put("ui_campaigns_listing_showing", Res.string.ui_campaigns_listing_showing)
  map.put("ui_campaigns_splash_desc", Res.string.ui_campaigns_splash_desc)
  map.put("ui_campaigns_splash_title", Res.string.ui_campaigns_splash_title)
  map.put("ui_company_dialog_btn_cancel", Res.string.ui_company_dialog_btn_cancel)
  map.put("ui_company_dialog_btn_confirm", Res.string.ui_company_dialog_btn_confirm)
  map.put("ui_company_dialog_btn_delete", Res.string.ui_company_dialog_btn_delete)
  map.put("ui_company_dialog_btn_rename", Res.string.ui_company_dialog_btn_rename)
  map.put("ui_company_dialog_btn_switch", Res.string.ui_company_dialog_btn_switch)
  map.put("ui_company_dialog_delete_title", Res.string.ui_company_dialog_delete_title)
  map.put("ui_company_dialog_delete_warning", Res.string.ui_company_dialog_delete_warning)
  map.put("ui_company_dialog_rename_placeholder", Res.string.ui_company_dialog_rename_placeholder)
  map.put("ui_company_dialog_rename_title", Res.string.ui_company_dialog_rename_title)
}
